import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { cn } from '../../lib/utils';
import type { StandingsCategory } from '../../services/category-standings';

/** The filter's value for "every class". */
export const ALL_CATEGORIES = 'all';

interface CategoryResultsFilterProps {
  categories: StandingsCategory[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/** Every class, or one of them: the pick on top of a stage's results. */
export function CategoryResultsFilter({ categories, value, onChange, className }: CategoryResultsFilterProps) {
  const { t } = useTranslation();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={cn('w-full sm:w-56', className)} aria-label={t('competitionStandings.filter')}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_CATEGORIES}>{t('competitionStandings.allCategories')}</SelectItem>
        {categories.map((category) => (
          <SelectItem key={category.id} value={category.id}>
            {category.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default CategoryResultsFilter;
